import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute } from '@tanstack/react-router';
import { BarChart3 } from 'lucide-react';
import { AiUsageStatsView } from '../~statistics/components';

export const Route = createFileRoute('/admin-console/ai/usage-billing')({
    staticData: {
        breadcrumb: {
            title: 'Usage and billing',
        },
        ui: {
            icon: BarChart3,
            title: 'Usage and billing',
            subtitle: 'Monitor AI token usage and costs across organisations and users.',
            widthVariant: 'default',
            menuDescription: 'View AI usage and billing statistics',
        },
    },
    component: UsageBillingPage,
});

function UsageBillingPage() {
    return (
        <PageController route={Route}>
            <AiUsageStatsView />
        </PageController>
    );
}
